import clsx from "clsx";
import useToggle from "hooks/useToggle";
import React, { useEffect, useState } from "react";
import SpaceList from "../SpaceList";
import SpaceDetails from "../SpaceDetails";
import { getFromStorage } from "helpers";
import { useNavigate } from "react-router-dom";
import { flowActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";

export default function Space() {
    const [expandConversation, toggleExpandConversation] = useToggle();
    const [mode, setMode] = useState("flow");
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { flowModeSuccess } = useAppSelector((state) => state.flow);

    const user = getFromStorage("ally-user");
    const handleToggleExpandConversation = () => {
        toggleExpandConversation();
    };

    const isGuest = !!user?.isGuest;

    const contentProps = {
        expandConversation,
        handleToggleExpandConversation,
        isGuest,
    };

    const handleModeChange = (mode: string) => {
        if (mode !== "flow") {
            dispatch(flowActions.setFlowMode(mode));
        }
        setMode(mode);
    };

    useEffect(() => {
        if (Boolean(flowModeSuccess)) {
            navigate("/dashboard/home");
        }
    }, [flowModeSuccess]);

    return (
        <div
            className="h-screen overflow-x-hidden w-screen p-[10px] md:p-[32px] z-[2000] flex flex-col gap-3"
            style={{
                background:
                    "linear-gradient(rgb(188, 244, 205) 0%, rgb(231, 251, 190) 148.14%, rgb(255, 253, 248) 188.76%)",
            }}
        >
            {!isGuest && (
                <div className="flex items-center justify-between gap-2">
                    <img
                        src="https://storage.googleapis.com/heysynth_files/synth_web/HeySynth%20Logo.svg"
                        alt="Powered by"
                        className="w-[30px]"
                    />

                    <div className="flex bg-[#FFFFFF4D] backdrop-blur-lg rounded-lg p-1">
                        {[
                            {
                                title: "Operator mode",
                                mode: "operator",
                                icon: "ri-tools-fill",
                            },
                            {
                                title: "Flow mode",
                                mode: "flow",
                                img: "https://storage.googleapis.com/heysynth_files/synth_web/wave-line.svg",
                            },
                        ].map((item) => (
                            <div className="font-rocGroteskMedium">
                                <button key={item.mode} onClick={() => handleModeChange(item.mode)}>
                                    <div
                                        className={clsx(
                                            mode === item.mode &&
                                                mode === "flow" &&
                                                "bg-white  !border-[#00C6FA] rounded-md",
                                            mode === item.mode &&
                                                mode === "operator" &&
                                                "bg-white  !border-[#FD700B] rounded-md",
                                            `flex items-center gap-1.5 border border-transparent py-0.5 px-3 cursor-pointer`
                                        )}
                                    >
                                        {item?.icon ? (
                                            <i className={`${item.icon} text-[#FD700B]`}></i>
                                        ) : (
                                            <img src={item?.img} alt="flow" className="w-4 h-4" />
                                        )}
                                        <p
                                            className={clsx(
                                                mode === item.mode ? "text-g-75" : "text-slate-500",
                                                "text-[13px]"
                                            )}
                                        >
                                            {item.title}
                                        </p>
                                    </div>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div
                className={clsx(
                    "w-full h-full flex transition-all duration-300 ease-in-out overflow-x-hidden",
                    expandConversation ? "gap-0" : "gap-[16px]"
                )}
            >
                <div
                    className={clsx(
                        expandConversation ? "w-[0%]" : "w-[376px]",
                        "transition-all duration-300 ease-in-out h-full"
                    )}
                >
                    <SpaceList {...contentProps} />
                </div>

                <SpaceDetails {...contentProps} />
            </div>

            {isGuest && (
                <div className="flex items-center justify-center gap-2">
                    <p className="text-sm font-rocGroteskMedium">Powered by</p>
                    <img
                        src="https://storage.googleapis.com/heysynth_files/synth_web/HeySynth%20Logo.svg"
                        alt="Powered by"
                        className="w-[30px]"
                    />
                    <p className="text-sm font-rocGroteskMedium">
                        <a
                            href="https://calendly.com/lloyd-synthally/30min"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="underline"
                        >
                            Discover
                        </a>{" "}
                        how consumer brands stay lean and agile with AI.
                    </p>
                </div>
            )}
        </div>
    );
}
